package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.w3c.dom.events.Event

class ModalState {
    var content by mutableStateOf<(@Composable () -> Unit)?>(null)
        private set
    var modifier by mutableStateOf<Modifier>(Modifier)
        private set
    var closeableOutside by mutableStateOf(true)
        private set

    fun show(
        customModifier: Modifier = Modifier,
        closeableOutside: Boolean = true,
        modalContent: @Composable () -> Unit
    ) {
        val wasOpen = content != null
        content = modalContent
        this.closeableOutside = closeableOutside
        modifier = customModifier
        
        if (!wasOpen) {
            window.history.pushState("KOBWEB_MODAL_OPEN", "", window.location.href)
        }
    }

    fun hide(fromBackButton: Boolean = false) {
        if (content == null) return
        content = null
        modifier = Modifier
        closeableOutside = true
        
        if (!fromBackButton) { window.history.back() }
    }
}

val modalStyle = CssStyle {
    base {
        Modifier.margin(leftRight = 1.cssRem)
    }
    Breakpoint.SM {
        Modifier.margin(leftRight = 2.cssRem)
    }
    Breakpoint.MD {
        Modifier.margin(leftRight = 4.cssRem)
    }
    Breakpoint.LG {
        Modifier.margin(leftRight = 6.cssRem)
    }
    Breakpoint.XL {
        Modifier.margin(leftRight = 20.cssRem)
    }
}

val LocalModal = compositionLocalOf<ModalState> { error("No ModalState provided") }

@Composable
fun ModalContainer(state: ModalState) {
    val currentContent = state.content
    val scope = rememberCoroutineScope()

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { event ->
            val isModalState = try {
                event.asDynamic().state == "KOBWEB_MODAL_OPEN"
            } catch (_: dynamic) {
                false
            }
            if (state.content != null && !isModalState) {
                scope.launch {
                    if (state.closeableOutside) {
                        state.hide(fromBackButton = true)
                    } else {
                        window.history.forward()
                    }
                }
            }
        }
        window.addEventListener("popstate", listener)
        onDispose {
            window.removeEventListener("popstate", listener)
        }
    }

    if (currentContent != null) {
        Box(
            Modifier
                .position(Position.Fixed)
                .top(0.px).left(0.px)
                .width(100.vw).height(100.vh)
                .backgroundColor(Colors.Black.copyf(alpha = 0.65f))
                .zIndex(9998)
                .display(DisplayStyle.Flex)
                .justifyContent(JustifyContent.Center)
                .alignItems(AlignItems.Center)
                .onClick {
                    if (state.closeableOutside) {
                        state.hide()
                    }
                }
                .userSelect(UserSelect.None)
        ) {
            Box(
                modalStyle.toModifier()
                    .maxHeight(90.vh)
                    .maxWidth(90.vw)
                    .overflow(com.varabyte.kobweb.compose.css.Overflow.Auto)
                    .backgroundColor(Colors.White)
                    .borderRadius(1.cssRem)
                    .padding(2.cssRem)
                    .boxShadow(0.px, 10.px, 15.px, color = Colors.Black.copyf(alpha = 0.3f))
                    .onClick { it.stopPropagation() }
                    .then(state.modifier)
            ) {
                currentContent()
            }
        }
    }
}